import {cl, showTime, start, stop, show, globs, getTime,constant,
  getLocalStorage,az,} from './utils';
import {dbVals, putSite} from './http'; // , putStream
import {getToken, getSiteId} from './httpauth';
import zlib from 'react-zlib-js'
import {saveBrowserAccess,cache,wsTrans,sensorIds,cl2} from '../../usa/utils/utils'
import {lc} from './landruConstants'
import {pInd,pi,tableRange} from './paramIds'
import {acctFeature} from '../../usa/components/C18utils'
var config = require('./config');
config = config.default || config;

// import {buffer} from 'buffer'
// cl(zlib)
// import {sensorIds} from '../../usa/utils/utils'


// var globWs = 0;

// function testWs(){
//   cl("testing ws")
//   let ws = new WebSocket("ws://l4ol.com:constant.contWebSocket");
//   globWs = ws
//   ws.onopen = e=>onOpen(e);
//   ws.onclose = e=>onClose(e);
//   ws.onmessage = e=>onMessage(e);
//   ws.onerror = e=>onError(e);
// }

var iv = {
  ws: null,
  key: 0,
  callBacks: {},
};

// var lastShowPeriodicMinute=0

var makePeriodicTime=()=>{
  let minute=Math.floor(getTime()/60)
//   if(minute!=lastShowPeriodicMinute){
//     lastShowPeriodicMinute=minute
    let hr=Math.floor(minute/60)%24
    let mn=minute%60
    let sc=Math.floor(getTime())%60
    return(`utc:${az(hr,2)}:${az(mn,2)}:${az(sc,2)}`)
//     cl(`utcTime: ${az(hr,2)}:${az(mn,2)}:${az(sc,2)}`)
//   }

}

var flowSensors={}

var makeFlowSensors=(gwType)=>{
  if(gwType!=1900)return
  let base=pInd[1900].pearl_gen_sens_conf[0]+pi[1900].pearl_gen_sens_conf["sensorType"]
  let mult=pInd[1900].pearl_gen_sens_conf[2]
  let baseS=pInd[1900].pearl_gen_sens_stat[0]+pi[1900].pearl_gen_sens_stat["adjValue"]
  let multS=pInd[1900].pearl_gen_sens_stat[2]
  Object.keys(dbVals.z||{}).filter(k=>!isNaN(k)).forEach(zInd=>{
    let zCh=dbVals.z[zInd][240]
    if(!zCh){return}// zone config not loaded yet
    for(let i=0;i<128;i++){
      let pid=base+i*mult
      let pidS=baseS+i*multS
      let key=`${zInd}-${pidS}`
      if((zCh[pid]==constant.GENTYPE_FLOW)&&(!flowSensors[key])){
        let val=+zCh[pidS]
//         cl(val)
        flowSensors[key]={ts:0,val:val,flow:0}
      }
    }
  })
//   cl(flowSensors)
}

var getFlowSensor=(zInd,gsInd)=>{
  let baseS=pInd[1900].pearl_gen_sens_stat[0]+pi[1900].pearl_gen_sens_stat["adjValue"]
  let multS=pInd[1900].pearl_gen_sens_stat[2]
  let pidS=baseS+gsInd*multS
  return flowSensors[`${zInd}-${pidS}`]||{}
}

var checkFlowSensors=(p)=>{
  var doNoFlow=(key,fs)=>{// called by fs.to
    let now=getTime()
    let noFlow=now-fs.ts// time since last flow
//     if(key=="0-22537"){
//       cl(`doNoFlow ${key}`)
//       cl(now,noFlow)
//     }
    if(noFlow<60){
      fs.flow=1/(noFlow/60)
      fs.to=setTimeout(e=>{doNoFlow(key,fs)},noFlow*1000)
    }else{
      fs.flow=0// done with noFlow
      fs.ts=0
    }
  }
  let key=`${p.z}-${p.i}`
//   cl(key)
  if(flowSensors[`${p.z}-${p.i}`]){
    let fs=flowSensors[`${p.z}-${p.i}`]
    let now=getTime()
    let elapse=now-fs.ts
    if(elapse>5){
      if(fs.ts){// we have a reading - &&(elapse>5)
        let dif=p.d-fs.val
        fs.flow=dif/(elapse/60)// gal / min
        clearTimeout(fs.to)
        fs.to=setTimeout(e=>{doNoFlow(key,fs)},72*1000/fs.flow)
      }
      fs.ts=now
      fs.val=+p.d
//       if(key=="0-22537"){cl(key,fs.ts,fs.val)}
    }
  }
//   cl(p)
}

var lastWsData00={}

var handleData00=(mo)=>{
  lastWsData00={ts:getTime(),gw:mo.gatewayId}
  if(mo.s!=globs.userData.session?.siteId){return}// not current site
//   cl2(mo)
//   cl("data00");
//   if(mo.clientId=="20313034464b500a00320025"){
//     cl(globs.userData.session.siteId)
//     let got51=false
//     mo.params.forEach(p=>{
//       if(p.id==51){got51=true}
//     })
//     if(got51){cl(mo.params)}
//     showPeriodicTime()
//     cl(makePeriodicTime(),mo)
//   }

//   let z = mo.zone;
//   cl(mo)
//   cl(mo.params)
  if(!mo.params){mo.params=[]}
  mo.params.forEach(p=>{
//     cl(`data00: ${JSON.stringify(p)}`)
//     cl(z, p.c, p.i, p.d)
//     cl(p.i,p.d)
    try{
//       cl(p)
//       if((p.i==104)&&(p.c==0)) {
//         cl(`chan 0: ${p.d}`)
//       }
//       cl(p.i,lc.SN_cloudStatus_t_CurrentTime)
      if(p.i==lc.SN_cloudStatus_t_CurrentTime){
//         if(p.z==1){
//           cl(`Time Received from zone 1: ${p.d}`)
//           cl(mo.params)
//         }
//         cl(p)
//         cl(globs.userData.session)
        let now=getTime()
        let sess=globs.userData.session
        if(!sess.zoneTimeOffsets){sess.zoneTimeOffsets={}} //for hdhTimer
        if(!sess.zoneTimeOffsets[sess.siteId]){sess.zoneTimeOffsets[sess.siteId]={}}
        sess.zoneTimeOffsets[sess.siteId][p.z]=p.d-Math.floor(now)
//         cl(now,p.d)
//         cl("got current time")
      }
      let dx=dbVals.z[p.z][p.c][p.i]
      if((dx!=null)&&(typeof dx=="object")){
        dx.val = p.d
//         cl("hook")
        dx.upd.forEach(upd=>{
          upd.f(upd)
//           cl(upd)
        })// update notifications
      }else{
        dbVals.z[p.z][p.c][p.i] = p.d;
      }
      checkFlowSensors(p)
    }catch{}
//     if (p.i === 23){
//       cl("inTemp Change from Site: " + p.d);
//     }
//     if (p.i === 4642){
//       cl("Setpoint Change from Site: " + p.d);
//     }
  });
  globs.events.publish("data", mo);
}

var removeHook=(upd,z,c,ind)=>{
//   cl(upd)
//   cl([z,c,ind])
//   cl(dbVals.z[z][c][ind])
//   cl(dbVals)
  if(!dbVals?.z?.z?.c?.ind)return
  if(dbVals.z[z][c][ind].upd.length==1){
//     cl("remove " + ind)
    dbVals.z[z][c][ind]=dbVals.z[z][c][ind].val// no longer an object
    return
  }
//   cl(dbVals.z[z][c][ind])
  let updA=dbVals.z[z][c][ind].upd
  for(let i=0; i<updA.length; i++){
//     cl(i)
    if(updA[i].hookId==upd.hookId){
      updA.splice(i,1)
//       cl("found")
      return
    }
    
  }
//   dbVals.z[z][c][i].upd.forEach((u,i)=>{
//     cl(u)
//     cl(upd)
//     cl(dbVals.z[z][c][i])
//     if(u.hookId===upd.hookId){
//       cl(dbVals.z[z][c][i])
// //       dbVals.z[z][c][i].upd.splice(i,1)
//       cl(dbVals.z[z][c][i])
//     }
//   })
}

var hookId=0

var addDataHook=(upd, z, c, i)=>{
  // check to see if we already have one!
//   if(i==203){
//     cl([z, c, i])
//   }
//   cl(dbVals)
//   cl("add hook: " + i)
  
  if((!dbVals.z)||(!dbVals.z[z])||(!dbVals.z[z][c])) return
  upd.hookId=hookId++
//   cl(upd)
  if((typeof dbVals.z[z][c][i]) == "object"){
    dbVals.z[z][c][i].upd.push(upd)
//     let got=false
//     dbVals.z[z][c][i].upd.forEach(u=>{
//       if(u.f==upd.f) got=true
//     })
// //     cl(got)
//     if(!got)dbVals.z[z][c][i].upd.push(upd)
  }else{
//     cl("make object")
    let val = dbVals.z[z][c][i]
//     cl(val)
    dbVals.z[z][c][i]={val: val, upd: [upd]}
  }
//   cl(typeof dbVals.z[z][c][i])
//   cl([z, c, i])
}

var testHandleData00=()=>{
  cl("test handle")
  let p={
    z: 0,
    c: 240,
    i: 23,
    d: 66.5,
  }
  let mo={
    params: [p],
  }
  handleData00(mo);
}

var handleMsg=(mo)=>{
//   cl(mo)
  switch(mo.cmd){
    case "data00":
      handleData00(mo);
      break;
    default:
      break;
  }

}

var blobToBuf=(blob)=>{
  
}

var uploadTotal=0
var uploadCount=0
var lastContSync=0

var setClientId=async(zoneId)=>{
  if(!zoneId){return}
  cl("set client id",zoneId)
  let deviceId=getLocalStorage("deviceId")
//   cl(deviceId)
  if(!globs.zonesInfo.info){return}
  if(!globs.gatewaysInfo.info){return}
  let zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==zoneId})[0]
  if(!zone){return}
  let gw=globs.gatewaysInfo.info.filter(g=>{
    return g.gatewayId==zone.gatewayId})[0]
  if(!gw){return}
  let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/clientId",
    method: "update",
    sessionId: globs.userData.session.sessionId,
    body:{clientId:gw.clientId,deviceId:deviceId}})
}

var updateSyncStat=(cmd,msg)=>{
//   cl(cmd,msg)
  var msg2
  switch(msg.msg){
    case "pmpConfigUpload":
      cl("pmpConfigUpload")
      msg2={
        text:"Total Sync",
        color:"#408040",
      }
      lastContSync=getTime()+2
      break
    case "packSync":
//       cl("packSync")
      msg2={
        text:"Pack Sync",
        color:"#408040",
      }
      lastContSync=getTime()+2
      break
    case "upd":
      let elapse=Math.floor(getTime()-lastContSync)
      if(elapse>=0){
        let color="#4080C0"
        let text=(lastContSync)?`Sync ${elapse}s`:"Waiting"
        if(lastContSync&&(elapse>60)){
          color="#C04040"
          text="No Sync"
        }
        msg2={
          text:text,
          color:color,
        }
      }
      break
  }
//   msg2.gatewayType=msg?.gatewayType
  if(msg2){globs.events.publish("wsSyncStat",msg2)}
}

var doSyncStat=(mo)=>{
  let key=`${mo.s}-${mo.params[0].z}`
  let zone=globs.zonesInfo.info?.filter(z=>{
    return (z.siteId==mo.s)&&(mo.params[0].z==z.siteZoneIndex)
  })[0]
  if(!zone){return}
//   cl(zone)
  if(zone&&(globs.userData.session?.zoneId==zone?.zoneId)){
    if(lastContSync<getTime()){lastContSync=getTime()}
  }
}

// expansion-board id ranges (config + status), mirrors C18Expansion00.js's ourRanges.
// used to detect a live board-type/config change so the cached per-channel
// digital/analog classification (globs.sitesData.pearlChannels) can be
// invalidated immediately, app-wide - not only while the Expansion page happens
// to be mounted.
var xBoardIdRanges=[
  tableRange.CONFIG_EXPANSION_BOARDS,
  tableRange.EXPANSION_BOARDS,
  tableRange.CONFIG_EXPANSION_BOARDS_ANNEX,
]
var checkXBoardChange=(mo)=>{
  let changed=(mo.params||[]).some(p=>{
    return p.i&&xBoardIdRanges.some(r=>{return (p.i>=r[0])&&(p.i<r[1])})
  })
  if(changed){globs.userData.siteLoaded=null}
}

var doData00=(mo)=>{
//   cl(mo)
//   cl(globs)
  var zInd
//   cl(((sensorIds||{})["e0gn0"]||{}).name)
  if(mo.params && mo.params.length){
    if(mo.cmd=="data00"){// not run when we just get site data
      zInd=mo.params[0].z
      if((!zInd)&&(zInd!=0)){zInd=mo.z}
//       cl("setting contact time")
      let now=Math.floor(getTime())
      if(!globs.contacts[mo.s]){globs.contacts[mo.s]={}}
      globs.contacts[mo.s][zInd]=now
//       cl(mo)
    }
    uploadCount+=mo.params.length
// this cl really should not be disabled:
    // cl(`Data for ${mo.s}, zone ${zInd}`)
//     cl(mo)
    doSyncStat(mo)
    // cl(mo)
//     if(zInd==7){cl(mo)}
  }
  if (mo.key !== undefined){
    iv.callBacks[mo.key][0](mo);
  }else{
    handleMsg(mo);
  }
  if(mo.cmd=="data00"){
    checkXBoardChange(mo)
    globs.events.publish("newZoneData",mo)
  }
//   cl(globs.contacts)
}

var doData02=(mo)=>{
  if (mo.key !== undefined){
    iv.callBacks[mo.key][0](mo);
  }else{
    cl("doData02")
    handleMsg(mo);
  }
}

var doToClient=(mo)=>{
//   cl(mo)
  globs.events.publish("toClient",mo)
}

var recvSocket = async(msg)=>{
// msg is a "MessageEvent" object
// the data (msg.data) can be a string or a Blob, if it's been zipped'
//   cl("recvSocket")
//   cl(msg.data)
  var mo
//   cl(msg.data.length)
//   cl(typeof(msg))
//   cl(Object.keys(msg))
//   cl(Buffer.isBuffer(msg.data))
//   cl(Object.keys(msg.data).length)
//   cl(msg.cmd)
  if(typeof(msg.data)!="string"){
    mo=await uncompress(msg.data)// includes json parse
  }else{
    mo = JSON.parse(msg.data);
  }
//   cl(mo)
//   if(mo.cursite){cl(mo?.cursite.length)}
//   cl(mo.cmd,mo.params?.length)
//   cl(mo)
//   cl(typeof(msg.data))
//   cl(msg)
//   cl(msg.data)
//   cl(msg.data.length)
//   cl(Object.keys(msg.data).length)
//   cl(mo.cmd)
//   cl(mo.cmd)
  switch(mo.cmd){
    case "gotcursite00":
    case "data00":// was "gotcursite00"
      doData00(mo)
      break
    case "getCurZone00":
    case "getSensors00":
      iv.callBacks[mo.key][0](mo);
      break
    case "data01Resp":
//       cl(mo)
      if(mo.result?.result!="error"){
        cl("ws Publish saveOK")
        globs.events.publish("saveOK",mo)
        iv.callBacks[mo.key][0](mo);
      }else{
        cl("ws response: error")
      }
      return
    case "data02":
      doData02(mo)
//       cl(mo)
      break
    case "toClient":
      doToClient(mo)
      break
    default:
      break
  }
}

setInterval(e=>{
  uploadTotal=0.8*uploadTotal+0.2*uploadCount
  uploadCount=0
//   cl(`count: ${uploadTotal}`)
},1000)

/*
sendSocket is connected to the server. The server knows our session, and knows how to send a message to the site that we're connected to

*/

var sendSocket = (msg)=>{
//   cl("send socket");
//   cl(msg)
//   console.trace()
  return new Promise((r, e)=>{
//     cl(msg)
    msg.key = iv.key;
    iv.callBacks[msg.key] = [r, e];
    iv.key = (iv.key + 1) % 100 ;
    iv.ws.send(JSON.stringify(msg))
//     cl("sending 2")
    return 
//     cl(r)
//     try{
//       iv.ws.send(JSON.stringify(msg))
//       r(true)
//     }catch{
//       e(false)
//     }
  })
}

function sendPacks(z, packs, site, user){
  cl("send packs")
  let sendPack = {
    command: "data01",
    s: globs.userData.session.siteId,
//     site: site, //dbVals.site,
    user: user, // dbVals.user,
    sessionId: globs.userData.session.sessionId,
//     token: getToken(),
    zone: z,
    params: packs,
  }
  cl(sendPack)
  sendSocket(sendPack).then(r=>{
    cl(r);
  });
}

var checkNewSite=()=>{// if this is a new site, then load the info
//   cl(globs.userData.session)
//   cl("check new")
//   cl(globs.userData.session)
//   cl(globs.userData.session.siteId)
//   cl(globs.userData.siteLoaded)
  return new Promise((r,e)=>{
//     cl([globs.userData.siteLoaded,globs.userData.session.siteId])
//     siteLoaded: "0sna8jVYIh0xw6oF"
    if(globs.userData.siteLoaded==globs.userData.session.siteId){ r() }else{
      doGetCurSite(r,e)
    }
  })
}

var compress=(inp)=>{
  return new Promise((r,e)=>{
    var input=new Buffer.from(inp)// (inp, 'utf8');
    zlib.deflate(input, (er,buf)=>{
      if(er){
        e(er)
      }else{
        r(buf)
      }
      cl(er)
    })
  })
}

var unPackData=(buf)=>{//Uint8Array
// the data may come as stringified json, *or*
// a binary list of stringified json
// each has a 32 bit length, and the string
// if the processing fails, do the whole thing
  let ofs=0
  let len=buf.length
//   cl(`total length: ${len}`)
  let i=0
  let packs=[]
  while(ofs<len){
//     cl(ofs,len)
    let pLen=(new Uint32Array(buf.buffer.slice(ofs,ofs+4)))[0]
    let buf0=buf.slice(ofs+4,ofs+4+pLen)
    let str=buf0.toString("ascii")
    try{
      packs.push(JSON.parse(str))
    }catch{
//       cl("error in json parse")
//       cl(buf0.toString("ascii"))
      break// this is not a multipack
    }
    ofs+=pLen+4
    if(i++>10){break}
  }
//   cl(`final ofs: ${ofs}`)
//   cl(ofs,len)
  if(ofs==len){
    let mo=packs[0]
    mo.cursite=[].concat(...(packs.slice(1)))
    cl("return cursite MultiPack")
    return mo
  }else{// not a multi pack
    try{
      return JSON.parse(buf.toString())
    }catch{
      cl("Error in cursite Pack")
      return{}
    }
  }
}

var uncompress=(inp)=>{// inp is a blob, returns an object
  return new Promise(async (r,e)=>{
    let inp2=await inp.arrayBuffer()//Buffer.from(msg.data)
    let inp3=Buffer(inp2)
    
    zlib.inflate(inp3, (er,buf)=>{
      if(er){
        e(er)
      }else{
        r(unPackData(buf))
//         r(JSON.parse(buf.toString()))
      }
    })
  })
}

var getCurZoneData=(pack)=>{
// this does *not* cache
  return new Promise(async(r,e)=>{
//     cl("getZoneData")
    sendSocket(pack).then(re=>{
      r(re)
    })
  })
}

var eraseCurSiteCache=(siteId)=>{
  let wsID="cont"
  let msgObj={uri:"/cont/getCurSite",method:"retrieve"}
  let keys=[siteId]// siteId
  let re=undefined// to erase
//   cl(JSON.stringify(re))
  cache.save(wsID,msgObj,keys,re)
}

var getCurSiteData=(pack)=>{
//   cl("get cur site")
//   cl(pack)// cmd, site, and sessionId
  let wsID="cont"
  let msgObj={uri:"/cont/getCurSite",method:"retrieve"}
  return new Promise(async(r,e)=>{
    let keys=[pack.s]// siteId
    var res
    if(!globs.disableCache||acctFeature("enableCache")){
      cl("use cache")
//       cl(wsID)// cont
//       cl(msgObj)// uri: /cont/getCurSite
//       cl(keys)// [siteId]
      res=await cache.check(wsID,msgObj,keys,r,e)
//       cl(res)// true
      if(res){
        let start=getTime()
        sendSocket(pack).then(re=>{
//           cl(Object.keys(re))
//           cl(re.siteId,globs.userData.session.siteId)
          if((!re.siteId)||(re.siteId==globs.userData.session.siteId)){
            cl(`Got Real Data for ${re.siteId}: `+show("main"))//cl(`time: ${getTime()}`)
            putSite(re.cursite,true)// save to dbVals - whole site
            cache.save(wsID,msgObj,keys,re)
            re.cmd="dataAll"
            globs.events.publish("newZoneData",re)
          }
        })
        return
      }else{
        cl("No Cache for SiteData")
      }
    }
//     cl("send socket")
    sendSocket(pack).then(re=>{
      cache.save(wsID,msgObj,keys,re)
      r(re)
    })
//     if(res&&(!globs.disableCache)){
//     }else{
//     }
  })
}

var doGetCurZone=(res, rej)=>{
//   console.trace()
  let z=globs.zonesInfo.info
    .filter(z=>{return z.zoneId==globs.userData.session.zoneId})[0]
  if(!z||!globs?.userData?.session){return}
//   if(!z){return}
//     cl(z)
  let pack = {
    cmd: "getCurZone00",
    sessionId: globs.userData.session.sessionId,
    s:z.siteId,
    z:z.siteZoneIndex,
  }
//   cl(pack)
  cl(`Get Current Zone for ${globs.userData.session.zoneId} ${show("main")}`)
//   cl(dbVals.z)
  getCurZoneData(pack).then(async r=>{
    cl("Got Current Zone: "+show("main"))//cl(`time: ${getTime()}`)
//     cl(r)
    if(!r.params?.length) cl(`No data for zone ${pack.s}`)
    if(r.cmd === "getCurZone00"){
//     cl(dbVals.z)
      putSite(r.params, false);// just update zone
//     cl(dbVals.z)
      globs.events.publish("newZoneData")
      globs.userData.zoneLoaded=globs.userData.session.zoneId
    }
    res(r);
  })
}

var doGetSensors=async(siteId)=>{
//   cl("doGetSensors")
  let pack = {
    cmd: "getSensors00",
    sessionId: globs.userData.session.sessionId,
    s:siteId,
  }
  let start=getTime()
  let res=await sendSocket(pack)
  let temps=res.params.filter(p=>{return (p.i==23)&&(p.z<5)})
//   cl(temps)
//   cl(`elapsed: ${getTime()-start}`)
  putSite(res.params, false);// just update zone
//   cl(res)
}

var doGetCurSite=(res, rej)=>{
  showTime("curSite1")
  if(!globs?.userData?.session){return}
  let deviceId=getLocalStorage("deviceId")
  let pack = {
    cmd: "getcursite00",
    sessionId: globs.userData.session.sessionId,
    deviceId:deviceId,
    s: globs.userData.session.siteId,
  }
  cl(`Get Current for ${globs.userData.session.siteId} ${show("main")}`)
//   cl(globs.userData.session.features)
  globs.events.publish("waiting",{wait:true})
  let access={uri:`b_doGetCurSite_line302`,method:"retrieve",start:getTime()}
//   cl("doing getCurSite")
  getCurSiteData(pack).then(async r=>{
    showTime("curSite2")
    cl("Got Current: "+show("main"))//cl(`time: ${getTime()}`)
    globs.events.publish("waiting",{wait:false})
    if(!(r?.cursite.length||0)) cl(`No data for site ${pack.s}`)
    if(r?.cmd === "gotcursite00"){
//       cl("put site")
      putSite(r.cursite, true);// whole site
      globs.userData.siteLoaded=globs.userData.session.siteId
      dbVals.siteAuthorized = true;
      dbVals.wsInfo=r.wsInfo// for debugging
      access.elapse=getTime()-access.start
      saveBrowserAccess(access)
    }
//     cl(globs.userData.session.features)
    res(r);
  })
}

// var loginToWebSocket = (res, rej)=>{
//   let token = getToken();
//   let site = getSiteId();
//   let pack = {
//     command: "login00",
//     token: token,
//     site: site,
// 
//   };
//   start("ws2");
//   sendSocket(pack).then(r=>{// login
// //     cl(show("ws2"));
//     if (r.result === 'ok'){
//       doGetCurSite(res);
//     }
//   })
// }

var loginContWs=()=>{
  cl("loginContWs")
//   cl2("loginContWs","here")
//   cl(globs.userData.session.siteId)
//   cl(globs.userData.session.sessionId)
  let deviceId=getLocalStorage("deviceId")
  let msg={
    cmd:"setSessionId",
    sessionId:globs.userData.session?.sessionId,
    deviceId:deviceId,
    siteId:globs.userData.session?.siteId,
  }
  iv.ws.send(JSON.stringify(msg))
//   cl(msg)
}

// function onOpen(e){
var onOpen = (r, e)=>{
//   cl("onOpen");
// on open, "login", by sending the JWT and the site that we want.
/* this is the hard part!
we want to wrap web socket communication in a Promise
so, when we send a request, it has a "key", then, when the response comes back, we look up the key, and */
  cl("ws onOpen");
//   cl(globs.userData.session.siteId)
  let gws=globs.webSocket
  gws.open=true
  gws.res.forEach(re=>{re(true)})// activate the list of responses
  delete gws.res
  loginContWs()
  // this needs to be handled seperately:
//   if(globs.userData.siteLoaded==globs.userData.session.siteId){ r() }
//   doGetCurSite(r, e);
}

function onClose(e){
  cl("ws onClose");
  globs.webSocket.open=false
  globs.webSocket.res=null// added 20231203
//   cl(e)
}

// function onMessage(e){
//   cl("ws onMessage");
// //   cl("received: " + e.data)
//   let mo = JSON.parse(e.data);
//   cl(mo);
// //   putStream(JSON.parse(e.data));
// //   cl(mo);
// }

function onError(e){
  cl("ws onError");
  cl(e)
}

var sendWS = (pack)=>{
  cl(pack);
  iv.ws.send(JSON.stringify(pack))
//   cl(iv);
}

var connectToWS=async(siteId)=>{
  await openWS(constant.wsUrl)
  let regWS={
    cmd:"regWS",
    s:siteId,
    sessionId: globs.userData.session.sessionId,
  }
  sendSocket(regWS)
}

function openWS(uri){
/* this is to manage *the* websocket with the server*/
  let gws=globs.webSocket
//   console.trace()
//   cl(constant)
//   cl(config)
//   console.trace()
  return new Promise((r, e)=>{
//     cl(gws.open)
    if(gws.open){r(); return}
    cl("open ws: " + uri);
//     cl("still opening")
    if(gws.res){gws.res.push(r); return}// add it to the list of responses
    gws.res=[r]// create the list of responses
    try{// does no good!
      let ws = new WebSocket(uri);
      iv.ws = ws;
      ws.onopen = ()=>onOpen(r, e);
      ws.onclose = e=>onClose(e);
      ws.onmessage = e=>recvSocket(e);
      ws.onerror = e=>onError(e);
    }catch{}
  });
}

var checkContWs=()=>{
//   cl("checkContWs")
  if(globs.webSocket.open){return}
  if(!constant.wsUrl){return}
  openWS(constant.wsUrl)
}

setInterval(checkContWs,5000)

export {openWS, sendWS, sendSocket, sendPacks, addDataHook, removeHook, checkNewSite,doGetCurSite,doGetCurZone,updateSyncStat,setClientId,
  uploadTotal,doGetSensors,eraseCurSiteCache,connectToWS,lastWsData00,
  makeFlowSensors,getFlowSensor,
}
